<div class="website-content" style="max-width:72rem;padding:0 var(--wa-spacing-x-large) var(--wa-spacing-x-large) var(--wa-spacing-x-large);">
	<div class="wa-stack wa-gap-xl">
		<wa-button [routerLink]="['/frameworks']" appearance="plain" variant="neutral">&larr; Back to UI Frameworks</wa-button>
		<wa-card appearance="outlined">
			<div class="wa-stack wa-gap-m">
				<div class="wa-stack wa-gap-s">
					<h1 waHeading="xl" waText>WebAwesome Pro</h1>
					<p waBody="m" waText>Premium WebAwesome plugin &mdash; WaPage layout system with 18 sub-components &#40;banner, header, navigation, main, aside, footer, menu, dialog wrappers&#41; for full application shell composition. Includes Angular directive wrappers, slot projection with semantic HTML, and property binding support.</p>
					<div class="wa-cluster wa-gap-xs">
						<wa-tag pill variant="neutral">Java 25+</wa-tag>
						<wa-tag pill variant="neutral">JPMS Modular</wa-tag>
						<wa-tag pill variant="neutral">Angular 21</wa-tag>
						<wa-tag pill variant="neutral">TypeScript 5</wa-tag>
					</div>
				</div>
				<wa-divider></wa-divider>
				<div class="wa-stack wa-gap-xs">
					<div waCaption="s" waFontWeight="semibold" waText>COORDINATES &amp; MODULE</div>
					<p waBody="s" waText>Maven: com.jwebmp.plugins:web-awesome-pro</p>
					<p waBody="s" waText>JPMS Module: com.jwebmp.webawesomepro</p>
					<p waBody="s" waText>Built on: WebAwesome 1.0</p>
				</div>
				<wa-details open summary="Installation">
					<div class="wa-stack wa-gap-xs">
						@if (!useGradle) {
							<div class="code-block-wrapper">
								<div class="code-block-label" waCaption="s" waFontWeight="semibold" waText>Maven</div>
								<markdown [data]="mdContent_51" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
							</div>
						}
						@if (useGradle) {
							<div class="code-block-wrapper">
								<div class="code-block-label" waCaption="s" waFontWeight="semibold" waText>Gradle &#40;Kotlin DSL&#41;</div>
								<markdown [data]="mdContent_52" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
							</div>
						}
					</div>
				</wa-details>
				<wa-divider></wa-divider>
				<wa-details open summary="Features (9)">
					<div class="wa-stack wa-gap-xs">
						<p waBody="s" waColorText="quiet" waText>WaPage component with 18 sub-components for full application shell composition</p>
						<p waBody="s" waColorText="quiet" waText>11 layout containers &mdash; Banner, Header, Navigation, Main, Aside, Footer, and more</p>
						<p waBody="s" waColorText="quiet" waText>7 control components &mdash; SkipToContent, Menu, Toggle, DialogWrapper, and more</p>
						<p waBody="s" waColorText="quiet" waText>Angular directive wrappers via angular-awesome library</p>
						<p waBody="s" waColorText="quiet" waText>Slot projection with semantic HTML &#40;18 slots&#41;</p>
						<p waBody="s" waColorText="quiet" waText>Property binding support &#40;12 binding methods&#41;</p>
						<p waBody="s" waColorText="quiet" waText>CRTP fluent API for method chaining</p>
						<p waBody="s" waColorText="quiet" waText>&#64;NgImportReference and &#64;NgImportModule annotation integration</p>
						<p waBody="s" waColorText="quiet" waText>Comprehensive JUnit 5 test suite &#40;13 tests&#41;</p>
					</div>
				</wa-details>
				<wa-divider></wa-divider>
				<wa-details open summary="Quick Start">
					<markdown [data]="mdContent_53" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
				</wa-details>
				<wa-divider></wa-divider>
				<wa-details open summary="SPI Extension Points">
					<div class="wa-stack wa-gap-xs">
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="success">provides IPageConfigurator</wa-tag>
						</div>
					</div>
				</wa-details>
				<wa-details open summary="Prerequisites">
					<div class="wa-cluster wa-gap-xs">
						<wa-tag pill variant="neutral">Java 25 LTS</wa-tag>
						<wa-tag pill variant="neutral">Maven 3.9+</wa-tag>
						<wa-tag pill variant="neutral">Node.js 18+</wa-tag>
						<wa-tag pill variant="neutral">Angular 21+</wa-tag>
					</div>
				</wa-details>
				<wa-divider></wa-divider>
				<div class="wa-cluster wa-gap-s">
					<wa-tag pill variant="neutral">Upstream: https://webawesome.com/</wa-tag>
					<wa-tag pill variant="neutral">Source: https://github.com/JWebMP/WebAwesomePro</wa-tag>
				</div>
			</div>
		</wa-card>
		<div class="wa-stack wa-gap-m">
			<h2 waHeading="l" waText>Components &#40;13&#41;</h2>
			<p waBody="m" waText>Click any component to see its full API &mdash; properties, constructors, methods, events, slots, and examples.</p>
			<div class="wa-grid wa-gap-s" style="--min-column-size:18rem;">
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>WaCombobox</h4>
						<p waBody="s" waColorText="quiet" waText>Combination of a text input and a dropdown select that allows users to type to filter and select from a list of options. Supports single and multiple selection, labeling, hints, clearable state, and Angular form integration.</p>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="brand">10 props</wa-tag>
							<wa-tag pill variant="neutral">1 methods</wa-tag>
							<wa-tag pill variant="warning">7 events</wa-tag>
							<wa-tag pill variant="neutral">6 slots</wa-tag>
							<wa-tag pill variant="success">2 examples</wa-tag>
						</div>
						<wa-button [routerLink]="['/frameworks/web-awesome-pro/wa-combobox']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>WaFileInput</h4>
						<p waBody="s" waColorText="quiet" waText>File upload input control with single and multiple file selection, accepted file types, drag-and-drop, and Angular form integration via ControlValueAccessor &#40;value type: FileList&#41;.</p>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="brand">8 props</wa-tag>
							<wa-tag pill variant="warning">3 events</wa-tag>
							<wa-tag pill variant="neutral">3 slots</wa-tag>
							<wa-tag pill variant="success">2 examples</wa-tag>
						</div>
						<wa-button [routerLink]="['/frameworks/web-awesome-pro/wa-file-input']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>WaChart</h4>
						<p waBody="s" waColorText="quiet" waText>Base chart component with Chart.js integration. All chart types extend WaChartBase which provides shared properties for labels, axes, and legend.</p>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="brand">6 props</wa-tag>
							<wa-tag pill variant="success">1 examples</wa-tag>
						</div>
						<wa-button [routerLink]="['/frameworks/web-awesome-pro/wa-chart']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>WaBarChart</h4>
						<p waBody="s" waColorText="quiet" waText>Bar chart with grouped and stacked variants. Extends WaChartBase with Chart.js bar chart rendering.</p>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="brand">3 props</wa-tag>
							<wa-tag pill variant="success">1 examples</wa-tag>
						</div>
						<wa-button [routerLink]="['/frameworks/web-awesome-pro/wa-bar-chart']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>WaLineChart</h4>
						<p waBody="s" waColorText="quiet" waText>Line chart with tension and fill options. Supports smooth curves via tension and area fills.</p>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="brand">2 props</wa-tag>
							<wa-tag pill variant="success">1 examples</wa-tag>
						</div>
						<wa-button [routerLink]="['/frameworks/web-awesome-pro/wa-line-chart']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>WaPieChart</h4>
						<p waBody="s" waColorText="quiet" waText>Pie chart with segment customization. Displays data as proportional slices.</p>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="brand">2 props</wa-tag>
							<wa-tag pill variant="success">1 examples</wa-tag>
						</div>
						<wa-button [routerLink]="['/frameworks/web-awesome-pro/wa-pie-chart']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>WaDoughnutChart</h4>
						<p waBody="s" waColorText="quiet" waText>Doughnut chart with cutout and rotation options. A pie chart with a hole in the center.</p>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="brand">2 props</wa-tag>
						</div>
						<wa-button [routerLink]="['/frameworks/web-awesome-pro/wa-doughnut-chart']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>WaBubbleChart</h4>
						<p waBody="s" waColorText="quiet" waText>Bubble chart with x/y/radius data points. Each point is rendered as a circle with its radius encoding a third dimension.</p>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="brand">2 props</wa-tag>
						</div>
						<wa-button [routerLink]="['/frameworks/web-awesome-pro/wa-bubble-chart']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>WaScatterChart</h4>
						<p waBody="s" waColorText="quiet" waText>Scatter plot with point styles. Displays data as individual points on a Cartesian grid.</p>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="brand">4 props</wa-tag>
						</div>
						<wa-button [routerLink]="['/frameworks/web-awesome-pro/wa-scatter-chart']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>WaRadarChart</h4>
						<p waBody="s" waColorText="quiet" waText>Radar/spider chart for multi-axis comparison. Plots data across multiple axes radiating from a center point.</p>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="brand">2 props</wa-tag>
						</div>
						<wa-button [routerLink]="['/frameworks/web-awesome-pro/wa-radar-chart']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>WaPolarAreaChart</h4>
						<p waBody="s" waColorText="quiet" waText>Polar area chart with angular scales. Like a pie chart but each segment has equal angle and the radius encodes the value.</p>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="brand">2 props</wa-tag>
						</div>
						<wa-button [routerLink]="['/frameworks/web-awesome-pro/wa-polar-area-chart']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>WaSparkline</h4>
						<p waBody="s" waColorText="quiet" waText>Compact inline sparkline chart without axes or labels. Typically used for trend indicators in tables, cards, or dashboards.</p>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="success">1 examples</wa-tag>
						</div>
						<wa-button [routerLink]="['/frameworks/web-awesome-pro/wa-sparkline']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>WaIconFA</h4>
						<p waBody="s" waColorText="quiet" waText>Font Awesome icon with Pro styling integration. Extends WaIcon and accepts FontAwesome Pro icon enums, families &#40;Solid, Regular, Light, Thin, Duotone&#41;, and variants.</p>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="success">3 examples</wa-tag>
						</div>
						<wa-button [routerLink]="['/frameworks/web-awesome-pro/wa-icon-fa']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
			</div>
		</div>
	</div>
</div>